import React from 'react';
import createForm from "./../../forms/Form";
import DateTimeInput from "../../../form/DateTimeInput";
import CheckBox from "../../../form/CheckBox";

class BergmanInvoiceExportForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <DateTimeInput
                            name="startdate"
                            value={this.props.values.startdate}
                            label="Kezdés"
                            isClearable={true}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("startdate")}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            name="enddate"
                            value={this.props.values.enddate}
                            label="Vég"
                            isClearable={true}
                            showTime={false}
                            saveChanges={this.props.setFieldValue}
                            {...this.props.getFieldProps("enddate")}
                        />
                    </div>
                    <div className="col-sm-4">
                        <label className="control-label">&nbsp;</label>
                        <CheckBox
                            name="posfilter"
                            value={this.props.values.posfilter}
                            label="Pénztárgép nélküli számlák"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(BergmanInvoiceExportForm);
